import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {HttpService} from "../http/HttpService";
import {AdminScriptWidget, AdminScriptWidgetListResponse, UpdateScriptWidget} from "../http/protocol";


export class ScriptWidgetService extends AbstractAdminEntityService<AdminScriptWidget, AdminScriptWidgetListResponse> {

    constructor(http: HttpService) {
        super("/widgets", http)
    }

    updateWidget(id: number, dto: Partial<UpdateScriptWidget>): Promise<AdminScriptWidget> {
        return this.http.put(this.entityPath + "/" + id, dto);
    }
}